import NewTaskForm from './NewTaskForm'
import { useGetGroupsQuery } from '../groups/groupsApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
import { useParams } from 'react-router-dom'
import { useGetTasksQuery } from './tasksApiSlice'

const NewTask = () => {
    useTitle('geshtop-Exercise: New User')

    const { taskId } = useParams()

    const { task } = useGetTasksQuery("tasksList", {
        selectFromResult: ({ data }) => ({
            task: data?.entities[taskId]
        }),
    })

    const { groups } = useGetGroupsQuery("groupsList", {
        selectFromResult: ({ data }) => ({
            groups: data?.ids.map(id => data?.entities[id])
        }),
    })
  
    if (!groups?.length) return <PulseLoader color={"#FFF"} />

    const content = <NewTaskForm groups={groups} task={task} />

    return content
}
export default NewTask